<template>
    <div class="spinner">
        <b-spinner type="grow" variant="info" label="Loading..."></b-spinner>
    </div>
</template>

<script>
export default {
    name: "Spinner"
}
</script>

<style scoped>

</style>
